export default __webpack_public_path__ + "static/media/easylife.047a0022.jpg";